<div class="business-list-view col-md-12 padding-right-0 padding-left-0">

  <!-- Wireframe header (#panel-followers .section-hd + .panel-search). Old header in #legacyHeader. -->
  <div class="gs-biz-list-hd" *ngIf="useWireframeHeader; else legacyHeader">
    <div class="gs-biz-list-row">
      <div class="gs-biz-list-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
        Followers
        <span class="gs-biz-list-count" *ngIf="BusFollowers || revokedShow">({{totalCount || 0}})</span>
      </div>
      <!-- Members only ever had a static, non-clickable "All" here, so the filter is admin-only. -->
      <div class="gs-biz-list-actions" *ngIf="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true'">
        <div class="btn-group" dropdown>
          <button type="button" class="gs-biz-list-btn" dropdownToggle aria-controls="fol-filter-menu">
            {{filterName}}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
          </button>
          <ul id="fol-filter-menu" *dropdownMenu class="dropdown-menu dropdown-menu-right no-padding" role="menu">
            <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'All'" (click)="applyFilter('ALL')">All </a></li>
            <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Revoked'" (click)="applyFilter('REVOKED')">Revoked</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="gs-biz-list-search">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
      <input #wfFolSearch type="text" placeholder="Search followers…" aria-label="Search followers"
        (input)="onSearchfollower(wfFolSearch.value)">
      <button *ngIf="wfFolSearch.value" type="button" class="gs-biz-list-clear" aria-label="Clear search"
        (click)="wfFolSearch.value = ''; onSearchfollower('')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
  </div>

  <ng-template #legacyHeader>
  <div class="hpanel">
    <div class="Bnav panel-body border-radius-top-left-right-6">
      <div class="Bnav-item-11">
        <h6 class="fw-bold" data-toggle="tooltip" data-placement="top" title="{{businessData?.businessName}}">
          {{businessData?.businessName| truncate : 20 }}
        </h6>
        <div *ngIf="BusFollowers && !revokedShow">
          <p>
            {{ totalCount }} {{ totalCount <= 1 ? 'Follower' : 'Followers' }}
          </p>
        </div>
        <div *ngIf="revokedShow ">
          <p >{{totalCount}} {{totalCount  > 1 ? 'Revoked' : 'Revoked' }} </p>
        </div>
      </div>
      <div class="Bnav-item-22">
        <input #businessFollowersText type="text" class="form-control" placeholder="Search Follower" style="z-index: 1;"
          aria-label="Amount (to the nearest dollar)"
          (input)="onSearchfollower(businessFollowersText.value)">
      </div>
      <div class="Bnav-item-33"
        *ngIf="businessData?.isSuperAdmin === 'true' || businessData?.isAdmin === 'true'; else employeeScreen">
        <div class="btn-group ml-10" dropdown container="body">
          <button id="button-container" class="btn btn-primary   " dropdownToggle
            aria-controls="dropdown-container" style="border-radius: 8px !important; height: 32px !important;">
            <div class="filter-common" style="gap: 5px !important;">
              <span>{{filterName}}</span>
              <ng-icon name="tablerFilter"></ng-icon>
            </div>
          </button>
          <ul id="dropdown-container" *dropdownMenu class="dropdown-menu no-padding" role="menu"
            aria-labelledby="button-container">
            <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'All'" (click)="applyFilter('ALL')">All </a></li>
            <!-- <li role="menuitem"><a class="dropdown-item"  >Ignored</a></li> -->
            <li role="menuitem"><a class="dropdown-item" [class.selected]="filterName === 'Revoked'" (click)="applyFilter('REVOKED')">Revoked</a></li>
            <!-- <li role="menuitem"><a class="dropdown-item"  >Admin</a></li> -->
          </ul>
        </div>
      </div>
      <ng-template #employeeScreen>
        <div class="Bnav-item-33">
          <div class="btn-group ml-10" container="body">
            <button id="button-container"
              class="btn btn-primary dropdown-toggle  " aria-controls="dropdown-container" 
              style="border-radius: 8px !important; height: 32px !important;">
              <div class="filter-common" style="gap: 5px !important;">
                <span>All</span>
                <ng-icon name="tablerFilter"></ng-icon>
              </div>
            </button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  </ng-template>
  <ng-container *ngIf="loadAPIcall && !loadScroll">
    <div class="follower-body">
      <div class="col-sm-12 kcid col-md-6 col-lg-6 padding-right-5 padding-left-0"
        *ngFor="let n of [1, 2, 3, 4, 5, 6]">
        <app-common-skeleton [NameOftheScreen]="'usercardWireframe'"></app-common-skeleton>
      </div>
    </div>
  </ng-container>
  <div class="follower-body" *ngIf="(businessFollowers | async)?.length > 0" infiniteScroll [alwaysCallback]="true"
    [infiniteScrollDistance]="5" [infiniteScrollThrottle]="300" (scrolled)="onScrollDown()">

    <ng-container *ngIf="!AllRevokeData">
      <div class="col-sm-12 kcid col-md-6 col-lg-6 padding-right-5 padding-left-0"
        *ngFor="let data of (businessFollowers | async)">
        <app-user-card [userDataInput]="data" [config]="userCardConfig"
          [adminFlag]="businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true'" [button]="'PRIMARY'" [variant]="'wireframe'" [showStats]="false"
          [refresh]="true" [hideButton]="true"></app-user-card>
      </div>
    </ng-container>
    <!-- </div> -->

    <div class="follower-group" *ngIf="DefaultData">
      <div class="col-sm-12 kcid col-md-6 col-lg-6 padding-right-5 padding-left-0"
        *ngFor="let data of values?.follower | customFilter:{userName:searchKey}:false">
        <app-user-card [userDataInput]="data" [config]="userCardConfig"
          [adminFlag]="businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true'" [button]="'PRIMARY'" [variant]="'wireframe'" [showStats]="false"
          [refresh]="true" [hideButton]="true"></app-user-card>
      </div>
    </div>

    <div class="follower-body" *ngIf="AllRevokeData ">
      <div class="col-sm-12 kcid col-md-6 col-lg-6 padding-right-5 padding-left-0"
        *ngFor="let data of (businessFollowers | async)">
        <app-user-card [userDataInput]="data" [config]="userCardConfig"
          [adminFlag]="businessData?.isSuperAdmin == 'true' || businessData?.isAdmin == 'true'" [button]="'PRIMARY'" [variant]="'wireframe'" [showStats]="false"
          [refresh]="true" [hideButton]="true"></app-user-card>
      </div>
    </div>

    <ng-container *ngIf="loadScroll">
      <div class="col-sm-12 col-md-6 col-lg-6 padding-right-5 padding-left-0 pd-5" *ngFor="let n of [1, 2]">
        <app-common-skeleton [NameOftheScreen]="'usercardWireframe'"></app-common-skeleton>
      </div>
    </ng-container>

    <div class="col-sm-12 pl-1 end" *ngIf="stopScroll && (businessFollowers | async)?.length > 0 "
      style="text-align: center;padding-top: 1rem;">
      <div class="col-sm-12">
        <ng-icon name="tablerCircleCheck"></ng-icon>
      </div>
      <div class="col-sm-12">
        <p class="fontchange">You've reached the bottom of the page</p>
      </div>
    </div>
  </div>
  <div class="col-md-12 pad" *ngIf="(businessFollowers | async)?.length === 0 && showNoDatafound">
    <app-nodata-found [title]="noDatafound"></app-nodata-found>
  </div>